export default "__VITE_ASSET__i55Urxit__"